import {z} from 'zod';

/**
 * One offerable financing rate coordinate with its own rates. A down payment between brackets
 * floors onto the lower bracket of the same term and balloon and is priced with that bracket's
 * rates; below the lowest one it is refused.
 *
 * `nominalRate` and `apr` are the cell's stored % p.a. strings, verbatim. The backend withholds
 * them (null on every cell of the offer) when the product is not offered today; they are optional
 * until every backend publishes them, and absent means the same as withheld.
 */
export const FinancingCellSchema = z.object({
  termMonths: z.number(),
  downPaymentPercentage: z.number(),
  balloonPaymentPercentage: z.number().nullable(),
  nominalRate: z.string().nullable().optional(),
  apr: z.string().nullable().optional(),
});
export type FinancingCell = z.infer<typeof FinancingCellSchema>;
